import { Paper, styled } from '@mui/material';

export const DecarbHubTile = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'accent',
})<{ accent?: boolean }>(({ theme, accent }) => ({
  color: theme.palette.primary.contrastText,
  display: 'flex',
  flexDirection: 'column',
  minHeight: 600,
  height: '100%',
  pb: 10,
  ...(accent && {
    backgroundColor: theme.palette.background.accent,
  }),
}));
